import { render, staticRenderFns } from "./UpdateFormStatusModal.vue?vue&type=template&id=85a32c68&scoped=true&"
import script from "./UpdateFormStatusModal.vue?vue&type=script&lang=js&"
export * from "./UpdateFormStatusModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateFormStatusModal.vue?vue&type=style&index=0&id=85a32c68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a32c68",
  null
  
)

export default component.exports